import { makeStyles } from '@material-ui/core/styles';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  CustomerConditionType,
  GATriggerType,
  ModalType,
} from '../../app/types';
import icDelete20 from '../../assets/images/svg/ic-delete-20.svg';
import {
  deleteConditionsNode,
  setDefaultTemplate,
  setIsShowSettingBar,
  setSelectedNode,
} from '../../features/mainSlice';
import { openModal } from '../../features/modalSlice';

const useStyles = makeStyles(
  {
    root: {
      textAlign: 'right',
      width: '100%',
      height: '100%',
    },
  },
  {
    name: 'Group',
  },
);

const GroupComponent = ({ id }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const dispatch = useDispatch();
  const nodes = useSelector(store => store.ma.data?.nodes) || [];
  const selectedNode = useSelector(store => store.ma.selectedNode);
  const isActive = useSelector(store => store.ma.isActive);
  const isPreview = useSelector(store => store.ma.isPreview);
  const node = useMemo(() => nodes.find(n => n?.id === id), [nodes]);
  const isSelected = selectedNode?.id === id;
  const { triggerType } = node?.data || {};

  const isGAGroup = useMemo(
    () => Object.values(GATriggerType).includes(triggerType),
    [triggerType],
  );

  const isCustomerGroup = useMemo(
    () => Object.values(CustomerConditionType).includes(triggerType),
    [triggerType],
  );

  const onDelete = () => {
    let key = 'conditions';

    if (isGAGroup) {
      key = 'gaConditions';
    }

    if (isCustomerGroup) {
      key = 'customerConditions';
    }

    dispatch(
      openModal({
        modalType: ModalType.DIALOG_TEXT,
        modalProps: {
          title: t(`delete-${key}-modal.title`),
          content: t(`delete-${key}-modal.content`),
          cancelText: t(`delete-${key}-modal.cancelText`),
          submitText: t(`delete-${key}-modal.submitText`),
        },
        onClick: () => {
          dispatch(deleteConditionsNode(id));
          dispatch(setSelectedNode(null));
        },
      }),
    );
  };

  const onSelect = () => {
    if (!isPreview && !isSelected) {
      dispatch(setSelectedNode(node));
      dispatch(
        setDefaultTemplate({
          isShow: false,
        }),
      );
    }

    dispatch(setIsShowSettingBar(true));
  };

  return (
    <div className={classes.root} onClick={onSelect}>
      {!isActive && (
        <img
          style={{ cursor: 'pointer' }}
          onClick={() => onDelete()}
          src={icDelete20}
          alt="delete"
        />
      )}
    </div>
  );
};

export default GroupComponent;
